module.exports = __webpack_public_path__ + "static/media/car_cross.3ae32727.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/car_cross.png
// module id = 297
// module chunks = 0